import api from '../api'

export default {
  namespaced: true,
  state: {
    consulutationList: {}
  },
  mutations: {
    SET_CONSULATATION_LIST (state, data) {
      state.consulutationList = data
    }
  },
  actions: {
    GET_CONSULTATION_LIST ({ commit, dispatch }, { flag, keyword, pageNum, pageSize } = {}) {
      return new Promise((resolve, reject) => {
        let data = { pageNum: 1, pageSize: 10 }
        // 判断是否需要添加参数
        if (flag) data.moduleFlag = flag
        if (keyword) data.title = keyword
        if (pageNum) data.pageNum = pageNum
        if (pageSize) data.pageSize = pageSize

        api.getConsulationList({ data }).then((res) => {
          commit('SET_CONSULATATION_LIST', res.payload)
          resolve(res)
        }).catch((rej) => {
          window.myVue.$message.error(rej.message)
        })
      })
    },
    GET_CONSULTATION_DETAIL ({ commit, dispatch }, id) {
      let params = { newsId: id }

      return api.getConsulationDetail({ params }).then((res) => {
        commit('SET_CONSULATATION_LIST', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    UPDATE_CONSULTATION_INFO ({ commit, dispatch }, data) {
      return api.updateConsulation({ data }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    DELETE_CONSULTATION_INFO ({ commit, dispatch }, id) {
      let query = { id: String(id) }

      return api.deleteConsulation({ query }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    BATCH_DELETE_CONSULTATION_INFO ({ commit, dispatch }, ids) {
      let data= { newsId: ids }

      return api.batchDeleteConsulation({ data }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/consultation/store/index.js